
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[productSlug]/[variantSku]",
      function () {
        return require("private-next-pages/p/[productSlug]/[variantSku].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[productSlug]/[variantSku]"])
      });
    }
  